import { HttpClient, HttpResponse } from "@angular/common/http";
import { computed, inject, Injectable, Signal } from "@angular/core";
import { PROJECT_NUMBER } from "@features/project/constants/routes.constant";
import { BehaviorSubject, map, Observable, shareReplay, switchMap, tap } from "rxjs";
import { ProjectSpecifications, ProjectSpecificationsPayload } from "../types/project-specifications.type";

@Injectable()
export class ProjectSpecificationsDataService {
  private readonly _projectNumber: string = inject(PROJECT_NUMBER);

  private readonly _httpClient: HttpClient = inject(HttpClient);

  // eslint-disable-next-line @unicorn/consistent-function-scoping
  private readonly _basePath: Signal<string> = computed(() => `api/projects/${ this._projectNumber }`);

  private _update$: BehaviorSubject<void> = new BehaviorSubject<void>(undefined);

  public readonly data$: Observable<ProjectSpecifications> = this._update$
    .pipe(
      switchMap(() => this.fetchProjectSpecifications()
        .pipe(
          shareReplay({ bufferSize: 1, refCount: true })
        ))
    );

  private fetchProjectSpecifications (): Observable<ProjectSpecifications> {
    return this._httpClient.get<ProjectSpecificationsPayload>(`${ this._basePath() }?expand=SPECIFICATIONS`)
      .pipe(
        map((response: ProjectSpecificationsPayload) => response.specifications)
      );
  }

  /**
   * Reload data
   */
  public reload (): void {
    this._update$.next();
  }

  public update (projectSpecifications: ProjectSpecifications): Observable<HttpResponse<void>> {
    const parsedProjectSpecifications: ProjectSpecificationsPayload = {
      specifications: projectSpecifications
    };


    return this._httpClient.put<undefined>(`${ this._basePath() }?expand=SPECIFICATIONS`, parsedProjectSpecifications, { observe: "response" })
      .pipe(
        tap({
          finalize: () => {
            this._update$.next();
          }
        })
      );
  }
}
